import { BettyStart } from "./BettyStart";
import { styled, useTheme } from "@mui/material/styles";
import {
  Badge,
  Box,
  Button,
  Checkbox,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  GlobalStyles,
  FormControlLabel,
  FormGroup,
  IconButton,
  List,
  ListItem,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";
import logo from "../images/transparent-logo.png";
import logo1 from "../images/transparent-logo1.png";
import logo2 from "../images/transparent-logo2.png";
import logo3 from "../images/transparent-logo3.png";
import { FixturesOverview } from "./FixturesOverview";
import { BContainer } from "./BContainer";
import { Export } from "./Export";
import { fetchFromApi } from "../helpers/fetchFromApi";
import { fetchViaPost } from "../helpers/fetchViaPost";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TeamStrengthDialog } from "./TeamStrengthDialog";
import { AppBar } from "../styled-components/AppBar";
import { LeagueStandingsDialog } from "./LeagueStandingsDialog";
import { StatisticsDialog } from "./StatisticsDialog";
import { BettingDialog } from "./BettingDialog";
import { AdminUsersDialog } from "./AdminUsersDialog";
import { AdminToolsDialog } from "./AdminToolsDialog";
import { SimulationDialog } from "./SimulationDialog";
import { LeagueDisplay } from "./LeagueDisplay";
import { CONTROL_CENTER_NAV_HEIGHT, ControlCenter, ControlCenterNavigation } from "./ControlCenter";
import { ChessWorkspace } from "./ChessWorkspace";
import { getUserAccessLevel, FEATURES, hasFeatureAccess } from "../helpers/featureAccess";
import { UserDialog } from "./UserDialog";
import { extractFlag } from "../components/Help";
import "../parts/animation-button.css";
import { HtmlTooltip } from "../styled-components/HtmlTooltip";
import YoutubeModal from "./YoutubeModal";
import {
  getLatestWhatsNewEntry,
  getWhatsNewText,
  hasUnseenWhatsNew,
  persistWhatsNewView,
  whatsNewEntries,
} from "../help/whatsNew";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const strs = [
  "bWFyY3VzLWJiZ0B3ZWIuZGU=",
  "cGF0cmlrLnNjaG1pZHRAeW1haWwuY29t",
  "dGlwc3RlcmNvbXBhbnlAZ214LmRl",
  "dG9ta2x1ZXNlbmVyQHQtb25saW5lLmRl",
  "ZGVubmlzb21lbHRzY2hlbmtvQHdlYi5kZQ==",
  "emFzdGVyNjBAb25saW5lLmRl",
  "Zi5zcGllZ2VsQGhvdG1haWwuZGU=",
  "bWhlaWRidWVjaGVsQG1haWwuZGU=",
  "aGVpbWFubi5oQGFvbC5jb20=",
  "c3RlZmZlbndlaWNrLjFAZ214LmRl",
  "dGFzY2hlbGVlci50bWxAZ29vZ2xlbWFpbC5jb20=",
  "eWFubmljZ295bkBnbWFpbC5jb20=",
  "amVucy5zY2hlbmtlQGdvb2dsZW1haWwuY29t",
  "a3Vuei5zdDNmYW5AZ21haWwuY29t",
  "eWFubmljZ295bjU3QGdtYWlsLmNvbQ==",
  "bWlvczc4QGdteC5kZQ==",
  "dW5kZXJncm91bmRzYWFyQGFvbC5jb20=",
  "dGhvbWFzLmJ1c2xAZ21haWwuY29t",
  "dHJhaW5lcjhAZ214LmRl",
  "YnNiYXNzYm9vc3RlZEBnbWFpbC5jb20=",
  "WWFzaW4tU2NocmVpYmVyQHdlYi5kZQ==",
  "ZGF2aWRwYXVsc2VuMjgwNUBnbWFpbC5jb20=",
  "a2V2aW4ua3Vwa2EwNEBnbWFpbC5jb20=",
  "MWJlbm1ldHpuZXJAZ21haWwuY29t",
  "amFrb2Iua2xhdXR6c2NoQGdteC5kZQ==",
  "ZmVsdGk5MDBAd2ViLmRl",
  "amFubmlzc2lkZXJhc0B3ZWIuZGU=",
  "ZnJhbmNvdGFmdXJvQGdteC5kZQ==",
  "bWFyY3NraXBwZXJAd2ViLmRl",
  "cGFzY2FsYm9yeXNAZ21haWwuY29t",
  "MDdsZWh3YWxkMTJAd2ViLmRl",
  "YmVuYmFsazIuMEBnbWFpbC5jb20=",
  "YmVuYmFsazIuMEBnbWFpbC5jb20=",
  "bWFyaXVzLm1laXNidXJnQGdtYWlsLmNvbQ==",
  "cXVlbnRpbi5oZXJyZW5icnVlY2tAZ214Lm5ldA==",
  "ZGF2aWQuYm90c2NoZW5AZ21haWwuY29t",
  "anVhbm1hc3NhbmV0QGdteC5kZQ==",
  "cm9iZGVtYXJjbzk1QGxpYmVyby5pdA==",
  "cy5tb2VsbGVyNzlAZ21haWwuY29t",
  "Y2hyaXN0aWFuaGlsY2hlckBmcmVlbmV0LmRl",
  "bXIubW9saUB3ZWIuZGU=",
  "bGllc2tlLmJlbml0ekB0LW9ubGluZS5kZQ==",
  "ZGVtb2huQG91dGxvb2suZGU=",
  "Y2FwdGFpbi5jYXBzbG9jay5jY0BnbWFpbC5jb20=",
];

// Popovers normally clamp to 16px from the viewport, underneath the fixed nav.
// Keep two text rows clear below it, including when a long menu is clamped upward.
const navigationMenuInset = CONTROL_CENTER_NAV_HEIGHT + 48;
const navigationMenuProps = {
  marginThreshold: navigationMenuInset,
  PaperProps: { sx: { maxHeight: `calc(100% - ${2 * navigationMenuInset}px)` } },
};

export function LeagueDrawer() {
  const theme = useTheme();
  const { t } = useTranslation();

  const [startOpen, setStartOpen] = useState(false);
  const [legacyNavigation, setLegacyNavigation] = useState(false);
  const [startPage, setStartPage] = useState("home");
  const [startVisit, setStartVisit] = useState(0);
  const [entryRequest, setEntryRequest] = useState(null);
  const [userExport, setUserExport] = useState();
  const [user, setUser] = useState();
  const [dataMaintenanceAvailable, setDataMaintenanceAvailable] = useState(false);
  const [dataMaintenanceRequest, setDataMaintenanceRequest] = useState(0);
  const [teamStrengthsRevision, setTeamStrengthsRevision] = useState(0);
  const [evaluationRunning, setEvaluationRunning] = useState(false);
  const [controlCenterOpen, setControlCenterOpen] = useState(() => !new URLSearchParams(window.location.search).has("date") && !window.location.pathname.includes("/export"));
  const [controlCenterArea, setControlCenterArea] = useState("controlCenter");

  const [
    whatsNewDialogOpen,
    setWhatsNewDialogOpen,
  ] = useState(false);

  const [
    whatsNewIntroOpen,
    setWhatsNewIntroOpen,
  ] = useState(false);

  const latestWhatsNew =
    getLatestWhatsNewEntry();

  const hasNewWhatsNew =
    Boolean(
      latestWhatsNew &&
      user &&
      hasUnseenWhatsNew(
        user.last_seen_whats_new
      )
    );

  useEffect(() => {
    if (
      !user ||
      user.whats_new_auto_show !== true ||
      user.whats_new_intro_seen === true
    ) {
      return;
    }

    /*
     * Diese Einführung erklärt nur die Funktion
     * "What's New".
     *
     * Sie markiert die eigentlichen Neuigkeiten
     * ausdrücklich NICHT als gelesen.
     */
    setWhatsNewIntroOpen(true);
    rememberWhatsNewIntroSeen();
  }, [
    user,
  ]);


  function handleWhatsNewIntroClose() {
    /*
     * Nur schließen.
     *
     * Der Einführungshinweis bleibt ungelesen und
     * wird beim nächsten Einstieg erneut angezeigt.
     */
    setWhatsNewIntroOpen(false);
  }


  async function rememberWhatsNewIntroSeen() {
    /*
     * Das tatsächliche Anzeigen merkt sich nur den
     * gesehenen Einführungshinweis. Der aktuelle
     * What's-New-Stand bleibt davon unberührt.
     */
    setUser((current) => ({
      ...(current || {}),
      whats_new_intro_seen: true,
    }));

    try {
      await fetchViaPost(
        "save-settings",
        JSON.stringify({
          whats_new_intro_seen: true,
        })
      );
    } catch (error) {
      console.error(
        "Could not save What's New intro status:",
        error
      );
    }
  }


  async function markWhatsNewSeen() {
    if (
      !latestWhatsNew ||
      !hasNewWhatsNew
    ) {
      return;
    }

    try {
      const seenId = await persistWhatsNewView(
        latestWhatsNew,
        user?.last_seen_whats_new,
        async (entryId) => {
          const response = await fetchViaPost(
            "save-settings",
            JSON.stringify({
              last_seen_whats_new: entryId,
            })
          );

          if (!response.ok) {
            throw new Error(
              `Could not save What's New status (${response.status})`
            );
          }
        }
      );

      setUser((current) => ({
        ...(current || {}),
        last_seen_whats_new: seenId,
      }));
    } catch (error) {
      console.error(
        "Could not save What's New status:",
        error
      );
    }
  }


  function handleWhatsNewDialogClose() {
    /*
     * Nur schließen.
     * Der aktuelle Stand bleibt ungelesen
     * und NEW bleibt sichtbar.
     */
    setWhatsNewDialogOpen(false);
  }


  function handleWhatsNewOpen(
    event
  ) {
    event?.preventDefault?.();

    /*
     * NEW öffnet die eigentlichen Neuigkeiten
     * innerhalb der App.
     *
     * Das tatsächliche Öffnen markiert den aktuellen
     * Stand über die bestehende User-Speicherung als gesehen.
     */
    setWhatsNewDialogOpen(true);
    markWhatsNewSeen();
  }
  const [statisticsOpen, setStatisticsOpen] = useState(false);
  const [statisticsSection, setStatisticsSection] =
    useState("table_stats");
  const [statisticsAnchorEl, setStatisticsAnchorEl] = useState(null);

  const statisticsMenuOpen = Boolean(statisticsAnchorEl);

  const [bettingAnchorEl, setBettingAnchorEl] = useState(null);
  const [bettingOpen, setBettingOpen] = useState(false);
  const [bettingMode, setBettingMode] = useState("paper");

  const bettingMenuOpen = Boolean(bettingAnchorEl);

  function handleBettingClick(event) {
    setBettingAnchorEl(event.currentTarget);
  }

  function handleBettingClose() {
    setBettingAnchorEl(null);
  }

  function handleBettingSelect(mode) {
    setBettingMode(mode);
    setBettingAnchorEl(null);
    setBettingOpen(true);
  }

  /*
   * Interner Admin-Arbeitsbereich.
   *
   * Der Menüpunkt ist standardmäßig unsichtbar und
   * wird nur für die aktuelle Browser-Sitzung über
   * Control + Option + A ein- bzw. ausgeblendet.
   *
   * Die bisherige Gold-Schranke bleibt für diesen
   * ersten Trennungsschritt erhalten. Eine echte
   * serverseitige Admin-Rolle folgt mit der
   * User-Administration.
   */
  const [adminVisible, setAdminVisible] =
    useState(false);

  const [adminAnchorEl, setAdminAnchorEl] =
    useState(null);

  const [adminUsersOpen, setAdminUsersOpen] =
    useState(false);

  const [adminToolsOpen, setAdminToolsOpen] =
    useState(false);

  const adminMenuOpen =
    Boolean(adminAnchorEl) && getUserAccessLevel(user) === "admin";

  const isGold =
    String(
      user?.plan || ""
    ).toLowerCase() === "gold";

  const hasAdminAccess =
    getUserAccessLevel(user) === "admin";

  function handleStatisticsClick(event) {
    setStatisticsAnchorEl(event.currentTarget);
  }

  function handleStatisticsClose() {
    setStatisticsAnchorEl(null);
  }

  function handleStatisticsSelect(section) {
    setStatisticsSection(section);
    setStatisticsAnchorEl(null);
    setStatisticsOpen(true);
  }

  function handleAdminClick(event) {
    if (!hasAdminAccess) return;
    setAdminAnchorEl(event.currentTarget);
  }

  function handleAdminClose() {
    setAdminAnchorEl(null);
  }

  function handleAdminUsersOpen() {
    if (!hasAdminAccess) return;
    setAdminAnchorEl(null);
    setAdminUsersOpen(true);
  }

  function handleAdminUsersClose() {
    setAdminUsersOpen(false);
  }

  function handleAdminToolsOpen() {
    if (!hasAdminAccess) return;
    setAdminAnchorEl(null);
    setAdminToolsOpen(true);
  }

  function handleAdminToolsClose() {
    setAdminToolsOpen(false);
  }

  function handleAdminStatisticsSelect(section) {
    if (!hasAdminAccess) return;
    setStatisticsSection(section);
    setAdminAnchorEl(null);
    setStatisticsOpen(true);
  }

  useEffect(() => {
    function handleAdminShortcut(event) {
      if (
        event.ctrlKey &&
        event.altKey &&
        event.code === "KeyA"
      ) {
        event.preventDefault();

        /*
         * Interne Werkzeuge verwenden dieselbe Admin-Erkennung
         * wie die übrigen Arbeitsbereiche, nicht den Gold-Tarif.
         */
        if (hasAdminAccess) {
          setAdminVisible(
            (current) => !current
          );
          setAdminAnchorEl(null);
        }
      }
    }

    window.addEventListener(
      "keydown",
      handleAdminShortcut
    );

    return () => {
      window.removeEventListener(
        "keydown",
        handleAdminShortcut
      );
    };
  }, [hasAdminAccess]);

  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  async function getLeages() {
    try {
      const request = await fetchFromApi(
        "fetch-data-v3/leagues" +
          "?include=country" +
          "&select=id,name,country_id,type,sub_type,image_path" +
          "&per_page=50",
      );
      const { data: leagues } = await request.json();
      return leagues;
    } catch (e) {
      return [];
    }
  }

  async function getUser() {
    try {
      return await (await fetchFromApi("get-user")).json();
    } catch (e) {
      return {};
    }
  }

  async function fetchData() {
    const leagues = await getLeages();

    /*
     * Die vollständige Liste bleibt erhalten.
     * Die darunter bestehende Planlogik entscheidet
     * weiterhin ausschließlich darüber, welche Ligen
     * tatsächlich benutzt werden dürfen.
     */
    setAllLeagues(leagues);

    let user = await getUser();
    let userId = user.id;
    if (!userId) { window.location.assign("/sign-in"); return; }
    setUser(user);

    let bootstrapPreview = null;
    try {
      bootstrapPreview = await (
        await fetchViaPost("preview-user-bootstrap", JSON.stringify({}))
      ).json();
    } catch {
      // Der leichte Bestandscheck darf den normalen App-Start nicht blockieren.
    }

    var ls = [
  "Bundesliga",
  "2. Bundesliga",
  "Premier League",
  "La Liga",
  "Serie A",
];

let freeLeagues = leagues.filter((l) => ls.includes(l.name));

    const now = new Date();

    const plan =
      String(user?.plan || "free").toLowerCase();

    const planStartedAt =
      user?.planStartedAt
        ? new Date(user.planStartedAt)
        : null;

    const planExpiresAt =
      user?.planExpiresAt
        ? new Date(user.planExpiresAt)
        : null;

    const planHasStarted =
      !planStartedAt ||
      !Number.isNaN(planStartedAt.getTime()) &&
      planStartedAt <= now;

    const planHasNotExpired =
      !planExpiresAt ||
      !Number.isNaN(planExpiresAt.getTime()) &&
      planExpiresAt >= now;

    const hasFullLeagueAccess =
      plan === "gold" ||
      (
        plan === "silver" &&
        planHasStarted &&
        planHasNotExpired
      );

    if (
      bootstrapPreview?.access_valid === true &&
      Array.isArray(bootstrapPreview?.accessible_league_ids)
    ) {
      const accessibleIds = new Set(bootstrapPreview.accessible_league_ids.map(Number));
      setLeagues(leagues.filter((league) => accessibleIds.has(Number(league.id))));
    } else if (hasFullLeagueAccess) {
      setLeagues(leagues);
    } else {
      var country_id = 35376;
      freeLeagues = freeLeagues.filter(
        (l) => l.country_id !== country_id
      );
      setLeagues(freeLeagues);
    }
    //setLeagues(leagues);
  }

  useEffect(() => {
    fetchData();

    async function handleSubscriptionStart() {
      const params = new URLSearchParams(window.location.search);

      if (params.get("subscribe") !== "silver") {
        return;
      }

      try {
        const response = await fetchFromApi("create-paypal-subscription");
        const result = await response.json();

        if (!result?.ok || !result?.approvalUrl) {
          throw new Error("No PayPal approval URL returned");
        }

        // Query-Parameter entfernen, damit Zurück-Navigation
        // nicht versehentlich eine zweite Subscription erzeugt.
        window.history.replaceState(
          {},
          "",
          window.location.pathname
        );

        window.location.href = result.approvalUrl;
      } catch (error) {
        console.error("Silver subscription start failed:", error);
        alert(
          "Silver subscription could not be started. Please try again later."
        );
      }
    }

    handleSubscriptionStart();
  }, []);
  /*
   * leagues:
   *   weiterhin ausschließlich die für den User
   *   tatsächlich freigeschalteten Ligen.
   *
   * allLeagues:
   *   vollständige Sportmonks-Liste.
   *   Sie wird für die neue Liga-Ansicht benötigt,
   *   damit auch nicht freigeschaltete Ligen sichtbar
   *   bleiben können, ohne sie auswählbar zu machen.
   */
  const [leagues, setLeagues] = useState([]);
  const [allLeagues, setAllLeagues] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const [league, setLeague] = useState();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  async function handleSelect(league) {
    console.log("selected league", league);

    setLeague(league);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [anchorStandingsEl, setAnchorStandingsEl] = useState(null);
  const menuStandingsOpen = Boolean(anchorStandingsEl);
  const [standing, setStanding] = useState();

  const [simulationOpen, setSimulationOpen] = useState(false);

  const [userToken, setUserToken] = useState();

  const handleStandingsClick = (event) => {
    setAnchorStandingsEl(event.currentTarget);
  };

  function handleStandingsSelect(league) {
    setStanding(league);
  }

  const handleStandingsClose = () => {
    setAnchorStandingsEl(null);
  };

  const handleSimulationClick = () => {
    setSimulationOpen(true);
  };

  async function fetchUser() {
    try {
      const user = await getUser();
      setUser(user);
    } catch (e) {
      window.location.pathname = "sign-in";
    }
  }

  const [userDialogOpen, setUserDialogOpen] = useState(false);
  const [allUsers, setAllUsers] = useState([]);

  function handleSetAllUsers(value) {
    setAllUsers(value);
  }

  function handleSetUserDialogOpen(value) {
    setUserDialogOpen(value);
    if (!value) {
      fetchUser();
    }
  }

  function getParameterByName(name) {
    var url = decodeURIComponent(window.location.search);
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "=([^&#]*)", "g");
    var match,
      result = [];
    while ((match = regex.exec(url)) !== null) result.push(match[1]);
    return result;
  }

  function getLogo() {
    if (typeof user === "undefined") {
      return logo;
    }

    const plan = String(user?.plan || "free").toLowerCase();

    if (plan === "gold") {
      return logo3;
    }

    if (plan === "silver") {
      return logo2;
    }

    return logo1;
  }

  let teamSettings = (
    <Button
      id="basic-button"
      color="inherit"
      aria-controls={menuOpen ? "basic-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={menuOpen ? "true" : undefined}
      onClick={handleClick}
      sx={{ ml: 2 }}
    >
      Team Settings
    </Button>
  );
  let tooltipTeamSettings = (
    <HtmlTooltip
      title={<YoutubeModal title="" youtubeId="NgR8wr4fUsI"></YoutubeModal>}
    >
      {teamSettings}
    </HtmlTooltip>
  );
  let statistics = (
    <Button
      id="statistics-button"
      color="inherit"
      aria-controls={statisticsMenuOpen ? "statistics-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={statisticsMenuOpen ? "true" : undefined}
      onClick={handleStatisticsClick}
      sx={{ ml: 2 }}
    >
      Statistics
    </Button>
  );

  let betting = (
    <Button
      id="betting-button"
      color="inherit"
      aria-controls={bettingMenuOpen ? "betting-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={bettingMenuOpen ? "true" : undefined}
      onClick={handleBettingClick}
      sx={{ ml: 2 }}
    >
      Betting
    </Button>
  );

  let admin = (
    <Button
      id="admin-button"
      color="inherit"
      aria-controls={
        adminMenuOpen
          ? "admin-menu"
          : undefined
      }
      aria-haspopup="true"
      aria-expanded={
        adminMenuOpen
          ? "true"
          : undefined
      }
      onClick={handleAdminClick}
      sx={{ ml: 2 }}
    >
      Admin
    </Button>
  );

  let simulation = (
    <Button
      id="simulation-button"
      color="inherit"
      aria-haspopup="dialog"
      onClick={handleSimulationClick}
      sx={{ ml: 2 }}
    >
      Simulation
    </Button>
  );

  let help = (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        ml: 2,
      }}
    >
      <Button
        href="help"
        target="_blank"
        color="inherit"
        sx={{ ml: 0 }}
      >
        Help
      </Button>

      {hasNewWhatsNew && (
        <Button
          size="small"
          color="secondary"
          variant="contained"
          onClick={handleWhatsNewOpen}
          sx={{
            ml: 0.5,
            minWidth: 0,
            px: 0.75,
            py: 0.15,
            fontSize: "0.58rem",
            lineHeight: 1.4,
          }}
        >
          NEW
        </Button>
      )}
    </Box>
  );

  let tooltipHelp = (
    <HtmlTooltip
      title={<YoutubeModal title="" youtubeId="B_XyUFv99Qk"></YoutubeModal>}
    >
      {help}
    </HtmlTooltip>
  );
  let docs = (
    <Button
      href="https://docs.betty.works"
      target="_blank"
      color="inherit"
      sx={{ ml: 2 }}
    >
      Docs
    </Button>
  );
  let tooltipDocs = (
    <HtmlTooltip
      title={<YoutubeModal title="" youtubeId="eruPAUeu5ns"></YoutubeModal>}
    >
      {docs}
    </HtmlTooltip>
  );
  let pricing = (
    <Button
      href={`https://plans.betty.works/?token=${encodeURIComponent(
        window.location.pathname.slice(1)
      )}`}
      target="_blank"
      color="inherit"
      sx={{ ml: 2 }}
    >
      Pricing
    </Button>
  );
  let tooltipPricing = (
    <HtmlTooltip
      title={<YoutubeModal title="" youtubeId="VJHJu43C0SM"></YoutubeModal>}
    >
      {pricing}
    </HtmlTooltip>
  );
  let donate = (
    <a
      className="box__link button-animation"
      target="_blank"
      href="https://donate.betty.works/"
    >
      Donate
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </a>
  );
  let tooltipDonate = (
    <HtmlTooltip
      title={<YoutubeModal title="" youtubeId="75IN3ivwjkk"></YoutubeModal>}
    >
      {donate}
    </HtmlTooltip>
  );

  function closeAlternativeAreaDialogs() {
    setAdminToolsOpen(false);
    setAnchorEl(null);
    setAnchorStandingsEl(null);
    setStatisticsAnchorEl(null);
    setBettingAnchorEl(null);
    setLeague(undefined);
    setStanding(undefined);
    setStatisticsOpen(false);
    setBettingOpen(false);
    setSimulationOpen(false);
    if (userDialogOpen) handleSetUserDialogOpen(false);
    setWhatsNewDialogOpen(false);
  }

  function enterStart(page = "home") {
    if (typeof page !== "string" || page === "home") return enterControlCenter();
    if (!window.dispatchEvent(new Event("betty:before-navigation", {cancelable:true}))) return;
    setLegacyNavigation(false);
    setStartPage(typeof page === "string" ? page : "home");
    closeAlternativeAreaDialogs();
    setControlCenterOpen(false);
    setStartVisit((value) => value + 1);
    setStartOpen(true);
    window.history.replaceState(null, "", window.location.pathname);
  }

  function enterControlCenter() {
    if (!window.dispatchEvent(new Event("betty:before-navigation", {cancelable:true}))) return;
    setLegacyNavigation(false);
    window.history.replaceState(null, "", window.location.pathname);
    setStartOpen(false);
    closeAlternativeAreaDialogs();
    setControlCenterArea("controlCenter");
    setControlCenterOpen(true);
  }

  function returnToLegacyView() {
    if (!window.dispatchEvent(new Event("betty:before-navigation", {cancelable:true}))) return;
    setStartOpen(false);
    closeAlternativeAreaDialogs();
    setControlCenterOpen(false);
    return true;
  }

  function showControlCenterHome() {
    closeAlternativeAreaDialogs();
    setControlCenterArea("controlCenter");
  }

  function showControlCenterGames() { enterStart("games"); }

  function openGamesMode(mode) {
    if (!returnToLegacyView()) return;
    setEntryRequest({mode, resetDate:true, nonce:Date.now()});
  }

  function openControlCenterTeams(event) {
    closeAlternativeAreaDialogs();
    setControlCenterArea("teams");
    handleClick(event);
  }

  function openControlCenterStatistics() {
    closeAlternativeAreaDialogs();
    setControlCenterArea("statistics");
    handleStatisticsSelect("table_stats");
  }

  function openControlCenterSimulation() {
    closeAlternativeAreaDialogs();
    setControlCenterArea("simulation");
    handleSimulationClick();
  }

  function openControlCenterBetting() {
    closeAlternativeAreaDialogs();
    setControlCenterArea("betting");
    handleBettingSelect("paper");
  }

  function openControlCenterDataMaintenance() {
    closeAlternativeAreaDialogs();
    setControlCenterArea("games");
    setStartOpen(false);
    setControlCenterOpen(true);
    setDataMaintenanceRequest((value) => value + 1);
  }

  function openControlCenterSettings() {
    closeAlternativeAreaDialogs();
    setControlCenterArea("settings");
    setUserDialogOpen(true);
  }

  function openControlCenterHelp() {
    closeAlternativeAreaDialogs();
    setControlCenterArea("help");
    handleWhatsNewOpen();
  }

  function openControlCenterChess() {
    if (!hasAdminAccess) return;
    closeAlternativeAreaDialogs();
    setControlCenterArea("chess");
  }

  function getFixturesOverview() {
    if (!user?.id) return null;
    const path = window.location.pathname.slice(1);
    const exp = path.split("/");
    if (exp.length > 1 && exp[1] === "export") {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      if (typeof getParameterByName("q")[0] !== "undefined") {
        console.log("URL Params", urlParams);
        //var old=JSON.stringify({test:getParameterByName("q")[0], league:getParameterByName("l")[0]})
        return <BContainer uri={window.location.search} text="" />;
      }
      return <Export token={exp[0]} />;
    } else {
      return (
        <FixturesOverview
          onLeagueSelection={showControlCenterGames}
          onOverview={enterControlCenter}
          entryRequest={entryRequest}
          leagues={leagues}
          allLeagues={allLeagues}
          user={user}
          dataMaintenanceRequest={dataMaintenanceRequest}
          onDataMaintenanceStatusChange={setDataMaintenanceAvailable}
          onEvaluationRunningChange={setEvaluationRunning}
          teamStrengthsRevision={teamStrengthsRevision}
        />
      );
    }
  }

  return (
    <Box sx={{ display: "flex", minHeight:"100vh", bgcolor: legacyNavigation ? undefined : "#0e1b25" }}>
      <Dialog
        open={whatsNewIntroOpen}
        onClose={handleWhatsNewIntroClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {t("help.whatsNew.introTitle")}
        </DialogTitle>

        <DialogContent dividers>
          <Typography
            sx={{
              mb: 2,
              lineHeight: 1.7,
            }}
          >
            {t("help.whatsNew.introFirst")}
          </Typography>

          <Typography
            sx={{
              mb: 2,
              lineHeight: 1.7,
            }}
          >
            {t("help.whatsNew.introSecond")}
          </Typography>

          <Typography
            color="text.secondary"
            sx={{
              lineHeight: 1.7,
            }}
          >
            {t("help.whatsNew.introThird")}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleWhatsNewIntroClose}
          >
            {t("help.whatsNew.introClose")}
          </Button>

        </DialogActions>
      </Dialog>

      <Dialog
        open={whatsNewDialogOpen}
        onClose={
          handleWhatsNewDialogClose
        }
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          What's New
        </DialogTitle>

        <DialogContent dividers>
          <Typography
            color="text.secondary"
            sx={{ mb: 2 }}
          >
            {user?.language === "de"
              ? "Das ist neu in betty."
              : "Here's what's new in betty."}
          </Typography>

          <Box
            sx={{
              display: "grid",
              gap: 2,
            }}
          >
            {whatsNewEntries.map(
              (entry) => (
                <Box
                  key={entry.id}
                  sx={{
                    pb: 2,
                    borderBottom:
                      "1px solid",
                    borderColor:
                      "divider",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                    }}
                  >
                    {getWhatsNewText(
                      entry,
                      "title",
                      user?.language
                    )}
                  </Typography>

                  <Typography
                    sx={{ mt: 0.5 }}
                  >
                    {getWhatsNewText(
                      entry,
                      "shortText",
                      user?.language
                    )}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mt: 0.75,
                      lineHeight: 1.7,
                    }}
                  >
                    {getWhatsNewText(
                      entry,
                      "body",
                      user?.language
                    )}
                  </Typography>

                  {entry.helpTarget && (
                    <Button
                      href={`help?target=${entry.helpTarget}`}
                      target="_blank"
                      size="small"
                      sx={{
                        mt: 0.5,
                        px: 0,
                        textTransform:
                          "none",
                      }}
                    >
                      {user?.language === "de"
                        ? "Mehr erfahren"
                        : "Read more"}
                    </Button>
                  )}
                </Box>
              )
            )}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={
              handleWhatsNewDialogClose
            }
          >
            {t("help.whatsNew.close")}
          </Button>

        </DialogActions>
      </Dialog>

      <TeamStrengthDialog
        league={league}
        setOpen={(value) => {
          setLeague(value);
          if (!value) setTeamStrengthsRevision((current) => current + 1);
        }}
        user={user}
      />
      {controlCenterOpen && <GlobalStyles styles={{
        ".MuiDialog-root .MuiDialog-paper": {
          marginTop: `${CONTROL_CENTER_NAV_HEIGHT}px`,
          maxHeight: `calc(100% - ${CONTROL_CENTER_NAV_HEIGHT}px)`,
        },
        ".MuiDialog-root .MuiDialog-paperFullScreen": {
          height: `calc(100% - ${CONTROL_CENTER_NAV_HEIGHT}px)`,
        },
      }} />}
      <LeagueStandingsDialog league={standing} setOpen={setStanding} />
      <AdminUsersDialog
        open={hasAdminAccess && adminUsersOpen}
        onClose={handleAdminUsersClose}
      />

      <AdminToolsDialog
        user={user}
        open={hasAdminAccess && adminToolsOpen}
        onClose={handleAdminToolsClose}
        onStart={enterControlCenter}
        leagues={leagues}
        onOpenSeasonBaseStats={() => {
          setAdminToolsOpen(false);
          setStatisticsSection(
            "admin_table_stats"
          );
          setStatisticsOpen(true);
        }}
      />

      <StatisticsDialog
        open={statisticsOpen}
        setOpen={setStatisticsOpen}
        leagues={leagues}
        initialSection={statisticsSection}
        isGold={isGold}
        isAdmin={hasAdminAccess && adminVisible}
        onOpenOfficialStandings={(league) => setStanding(league)}
      />
      <BettingDialog
        open={bettingOpen}
        setOpen={setBettingOpen}
        mode={bettingMode}
      />
      <SimulationDialog
        open={simulationOpen}
        setOpen={setSimulationOpen}
        leagues={leagues}
        user={user}
      />
      <UserDialog
        user={user}
        open={userDialogOpen}
        setOpen={handleSetUserDialogOpen}
        allUsers={allUsers}
        setAllUsers={handleSetAllUsers}
      />
      <CssBaseline />
      {user && !legacyNavigation && (
        <ControlCenterNavigation
          user={user}
          activeArea={
            userDialogOpen ? "settings" : whatsNewDialogOpen ? "help" :
            statisticsOpen || simulationOpen || bettingOpen || adminUsersOpen || adminToolsOpen || league || standing || menuOpen || anchorStandingsEl ? "models" :
            startOpen ? (["games", "tips", "history", "profile"].includes(startPage) ? startPage : "models") :
            controlCenterOpen ? (controlCenterArea === "games" ? "games" : controlCenterArea === "chess" ? "models" : "start") : "games"
          }
          onStart={enterControlCenter}
          disabled={evaluationRunning}
          onControlCenter={() => enterStart("models")}
          onGames={showControlCenterGames}
          onOpenPage={enterStart}
          onTeams={openControlCenterTeams}
          onStatistics={openControlCenterStatistics}
          onSimulation={openControlCenterSimulation}
          onOracle={() => window.location.assign("?view=oracle")}
          onBetting={openControlCenterBetting}
          onDataMaintenance={openControlCenterDataMaintenance}
          onSettings={openControlCenterSettings}
          onHelp={openControlCenterHelp}
        />
      )}
      <AppBar
        position="fixed"
        open={open}
        sx={{ display: !legacyNavigation ? "none" : "block", zIndex: (theme) => theme.zIndex.modal + 1 }}
      >
        <Toolbar style={{ display: "flex", textWrap: "nowrap" }}>
          {/*<IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>*/}
          <a
            href={window.location.pathname}
            aria-label={t("help.start.home")}
            onClick={(event) => {
              event.preventDefault();
              enterStart();
            }}
          >
            <img src={getLogo()} style={{ height: "3em" }} alt="betty" />
          </a>
          <Button onClick={enterStart} aria-current={startOpen ? "page" : undefined} variant={startOpen ? "contained" : "text"} sx={{ mx: 1, flexShrink: 0 }}>
            {t("help.start.home")}
          </Button>
          <div style={{ display: startOpen ? "none" : undefined }}>
            {localStorage.getItem("showTutorials") === "true"
              ? tooltipTeamSettings
              : teamSettings}
            <Menu
              {...(!legacyNavigation ? navigationMenuProps : {})}
              id="basic-menu"
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {leagues?.map((league) => (
                <MenuItem onClick={() => handleSelect(league)}>
                  <LeagueDisplay league={league} />
                </MenuItem>
              ))}
            </Menu>
            <Menu
              {...(!legacyNavigation ? navigationMenuProps : {})}
              id="basic-menu"
              anchorEl={anchorStandingsEl}
              open={menuStandingsOpen}
              onClose={handleStandingsClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {leagues?.map((league) => (
                <MenuItem onClick={() => handleStandingsSelect(league)}>
                  <LeagueDisplay league={league} />
                </MenuItem>
              ))}
            </Menu>
            {statistics}

            {betting}

            {hasAdminAccess &&
              adminVisible &&
              admin}

            {simulation}
            <Button color="inherit" onClick={() => window.location.assign("?view=oracle")}>ORAKEL</Button>

            <Badge
              badgeContent="NEU"
              color="secondary"
              sx={{
                ml: 1.5,
                "& .MuiBadge-badge": {
                  fontSize: "0.52rem",
                  height: 15,
                  minWidth: 24,
                  px: 0.5,
                },
              }}
            >
              <Button
                color="inherit"
                size="small"
                onClick={enterControlCenter}
                sx={{ px: 1, textTransform: "none", fontWeight: 800 }}
              >
                {t("help.controlCenter.open")}
              </Button>
            </Badge>

            <Button
              color="inherit"
              size="small"
              title={dataMaintenanceAvailable ? "Datenpflege verfügbar" : "Kein Handlungsbedarf"}
              onClick={() => setDataMaintenanceRequest((value) => value + 1)}
              sx={{ ml: 0.5, px: 0.75, minWidth: 0, textTransform: "none", fontSize: "0.78rem", opacity: 0.9 }}
            >
              <Box
                component="span"
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  bgcolor: dataMaintenanceAvailable ? "warning.light" : "success.light",
                  mr: 0.75,
                }}
              />
              Datenpflege
            </Button>

            <Menu
              {...(!legacyNavigation ? navigationMenuProps : {})}
              id="betting-menu"
              anchorEl={bettingAnchorEl}
              open={bettingMenuOpen}
              onClose={handleBettingClose}
              MenuListProps={{
                "aria-labelledby": "betting-button",
              }}
            >
              <MenuItem onClick={() => handleBettingSelect("paper")}>
                Paper Betting
              </MenuItem>
              <MenuItem onClick={() => handleBettingSelect("real")}>
                Real Bets
              </MenuItem>
            </Menu>

            <Menu
              {...(!legacyNavigation ? navigationMenuProps : {})}
              id="admin-menu"
              anchorEl={adminAnchorEl}
              open={adminMenuOpen}
              onClose={handleAdminClose}
              MenuListProps={{
                "aria-labelledby":
                  "admin-button",
              }}
            >
              <MenuItem
                onClick={handleAdminUsersOpen}
              >
                Users
              </MenuItem>

              <MenuItem
                onClick={handleAdminToolsOpen}
              >
                Tools
              </MenuItem>
            </Menu>

            <Menu
              {...(!legacyNavigation ? navigationMenuProps : {})}
              id="statistics-menu"
              anchorEl={statisticsAnchorEl}
              open={statisticsMenuOpen}
              onClose={handleStatisticsClose}
              MenuListProps={{
                "aria-labelledby": "statistics-button",
              }}
            >

              <MenuItem
                onClick={() =>
                  handleStatisticsSelect(
                    "official_tables"
                  )
                }
              >
                Offizielle Tabellen
              </MenuItem>

              <MenuItem
                onClick={() =>
                  handleStatisticsSelect(
                    "table_stats"
                  )
                }
              >
                Meine Statistiken / betty Tabellen
              </MenuItem>


            </Menu>

            {localStorage.getItem("showTutorials") === "true"
              ? tooltipHelp
              : help}
            {localStorage.getItem("showTutorials") === "true"
              ? tooltipDocs
              : docs}
            {localStorage.getItem("showTutorials") === "true"
              ? tooltipPricing
              : pricing}
            {localStorage.getItem("showTutorials") === "true"
              ? tooltipDonate
              : donate}
          </div>{" "}
          <Box
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => setUserDialogOpen(true)}
              edge="start"
              sx={{ ml: 2, ...(open && { display: "none" }) }}
            >
              <SettingsIcon />
            </IconButton>
            {user?.name}{" "}
            {window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1"
              ? `(${window.location.host})`
              : ""}
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {leagues?.map(({ name, country }) => (
            <ListItem key={name}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5em",
                      }}
                    >
                      <img
                        style={{ width: "1em" }}
                        alt={country.name}
                        title={country.name}
                        src={`data:image/svg+xml;utf8,${encodeURIComponent(
                          extractFlag(country.extra),
                        )}`}
                      />

                      {name}
                    </div>
                  }
                />
              </FormGroup>{" "}
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Main open={open}>
        <DrawerHeader />

        {startOpen && user && hasFeatureAccess(FEATURES.BETTY_START, user) && <BettyStart key={`${user.id}:${startVisit}`} user={user} leagues={leagues} isAdmin={hasAdminAccess} initialPage={startPage}
          onUpdate={hasAdminAccess ? () => { returnToLegacyView(); setDataMaintenanceRequest(value => value + 1); } : undefined}
          onHome={enterControlCenter}
          onPageChange={setStartPage}
          onGames={showControlCenterGames}
          onDay={() => openGamesMode("day")}
          onWeek={() => openGamesMode("week")}
          onClassic={enterControlCenter}
          onStatistics={openControlCenterStatistics}
          onSimulation={openControlCenterSimulation}
          onSettings={openControlCenterSettings}
          onHelp={openControlCenterHelp}
          onBetting={openControlCenterBetting}
          onOracle={() => window.location.assign("?view=oracle")}
          onAnalyze={(fixture) => { setEntryRequest({ ...fixture, mode: "league", nonce: Date.now() }); returnToLegacyView(); }}
          onLeague={(league) => { setEntryRequest({ leagueId: league.league_id, seasonId: league.season_id, mode: "league", nonce: Date.now() }); returnToLegacyView(); }}
        />}
        {!startOpen && controlCenterOpen && !["games", "chess"].includes(controlCenterArea) && (
          <ControlCenter
            user={user}
            onOpenPage={enterStart}
            onAdminUsers={hasAdminAccess ? handleAdminUsersOpen : undefined}
            onAdminTools={hasAdminAccess ? handleAdminToolsOpen : undefined}
            onRealBetting={() => handleBettingSelect("real")}
            onGames={showControlCenterGames}
            onTeams={openControlCenterTeams}
            onStandings={handleStandingsClick}
            onStatistics={openControlCenterStatistics}
            onSimulation={openControlCenterSimulation}
          onOracle={() => window.location.assign("?view=oracle")}
            onBetting={openControlCenterBetting}
            onSettings={openControlCenterSettings}
            onDataMaintenance={openControlCenterDataMaintenance}
            onWhatsNew={openControlCenterHelp}
            onChess={openControlCenterChess}
            isAdmin={hasAdminAccess}
            dataMaintenanceAvailable={dataMaintenanceAvailable}
            hasNewWhatsNew={hasNewWhatsNew}
            plansUrl={`https://plans.betty.works/?token=${encodeURIComponent(window.location.pathname.slice(1))}`}
            donateUrl="https://donate.betty.works/"
          />
        )}
        {controlCenterOpen && controlCenterArea === "chess" && hasAdminAccess && (
          <ChessWorkspace />
        )}
        <Box sx={{ display: !startOpen && (!controlCenterOpen || controlCenterArea === "games") ? "block" : "none" }}>
          {!startOpen && (!controlCenterOpen || controlCenterArea === "games") && getFixturesOverview()}
        </Box>
      </Main>
    </Box>
  );
}
